module.exports = __webpack_public_path__ + "img/satan.d64fd5dd.png";